import { render, staticRenderFns } from "./TacheFormComponent.vue?vue&type=template&id=4ccc887c&"
import script from "./TacheFormComponent.vue?vue&type=script&lang=js&"
export * from "./TacheFormComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports